import * as i1$2 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, StoreModule } from '@ngrx/store';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, APP_INITIALIZER, NgModule, Optional } from '@angular/core';
import * as i1$3 from '@ngrx/effects';
import { createEffect, ofType, concatLatestFrom, EffectsModule } from '@ngrx/effects';
import { throwError, Subject, of } from 'rxjs';
import { catchError, filter, take, exhaustMap, switchMap, concatMap, withLatestFrom, distinctUntilChanged, map, mergeMap } from 'rxjs/operators';
import { createEntityAdapter } from '@ngrx/entity';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i1$1 from '@panamax/browser-storage';
import { MessageTypes } from '@panamax/browser-storage';
import * as i4 from '@panamax/app-state';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import { AlertEventActions } from '@usf/alert-types';
import * as i1$4 from '@panamax/websocket';

const getNotes = createAction('[NGRXTrace - Alerts] Get Notes', props());
const getNotesSuccess = createAction('[NGRXTrace - Alerts] Get Notes Success', props());
const getNotesFail = createAction('[NGRXTrace - Alerts] Get Notes Fail', props());
const markNoteAsRead = createAction('[NGRXTrace - Alerts] Mark Note as Read', props());
const markNoteAsReadSuccess = createAction('[NGRXTrace - Alerts] Mark Note as Read Success', props());
const markNoteAsReadFail = createAction('[NGRXTrace - Alerts] Mark Note as Read Fail', props());
//IndexedDB Actions
const writeToUserOfflineStorage$1 = createAction('[NGRXTrace - Alerts] Write To User Storage');
const loadFromUserOfflineStorage$1 = createAction('[NGRXTrace - Alerts] Load From User Storage', props());
const loadFromUserOfflineStorageSuccess$1 = createAction('[NGRXTrace - Alerts] Load From User Storage Success', props());
const loadFromUserOfflineStorageFail$1 = createAction('[NGRXTrace - Alerts] Load From User Storage Fail', props());
//end IndexedDB Actions
const NOTES_ACTIONS = {
    getNotes,
    getNotesSuccess,
    getNotesFail,
    markNoteAsRead,
    markNoteAsReadSuccess,
    markNoteAsReadFail,
    //IndexedDB
    writeToUserOfflineStorage: writeToUserOfflineStorage$1,
    loadFromUserOfflineStorage: loadFromUserOfflineStorage$1,
    loadFromUserOfflineStorageSuccess: loadFromUserOfflineStorageSuccess$1,
    loadFromUserOfflineStorageFail: loadFromUserOfflineStorageFail$1,
};

const getAlerts = createAction('[NGRXTrace - Alerts] Get Alerts', props());
const getAlertsSuccess = createAction('[NGRXTrace - Alerts] Get Alerts Success', props());
const getAlertsFail = createAction('[NGRXTrace - Alerts] Get Alerts Fail', props());
const getUnreadAlertsCount = createAction('[NGRXTrace - Alerts] Get My Unread Alerts Count', props());
const getUnreadAlertsCountSuccess = createAction('[NGRXTrace - Alerts] Get My Unread Alerts Count Success', props());
const getUnreadAlertsCountFail = createAction('[NGRXTrace - Alerts] Get My Unread Alerts Count Fail', props());
const markAlertAsRead = createAction('[NGRXTrace - Alerts] Mark Alert as Read', props());
const markAlertAsReadSuccess = createAction('[NGRXTrace - Alerts] Mark Alert as Read Success', props());
const markAlertAsReadFail = createAction('[NGRXTrace - Alerts] Mark Alert as Read Fail', props());
const getUnreadAlertsCountAsync = createAction('[NGRXTrace - Alerts] Get My Unread Alerts Count Async', props());
//IndexedDB Actions
const initializeUserStorage = createAction('[NGRXTrace - Alerts] - Initialize User Offline Storage', props());
const writeToUserOfflineStorage = createAction('[NGRXTrace - Alerts] Write To User Storage');
const loadFromUserOfflineStorage = createAction('[NGRXTrace - Alerts] Load From User Storage', props());
const loadFromUserOfflineStorageSuccess = createAction('[NGRXTrace - Alerts] Load From User Storage Success', props());
const loadFromUserOfflineStorageFail = createAction('[NGRXTrace - Alerts] Load From User Storage Fail', props());
//end IndexedDB Actions
const ALERTS_ACTIONS = {
    getAlerts,
    getAlertsSuccess,
    getAlertsFail,
    getUnreadAlertsCount,
    getUnreadAlertsCountSuccess,
    getUnreadAlertsCountFail,
    getUnreadAlertsCountAsync,
    markAlertAsRead,
    markAlertAsReadSuccess,
    markAlertAsReadFail,
    //IndexedDB
    initializeUserStorage,
    writeToUserOfflineStorage,
    loadFromUserOfflineStorage,
    loadFromUserOfflineStorageSuccess,
    loadFromUserOfflineStorageFail,
};

const registerDevice = createAction('[NGRXTrace - Alerts] Register Device', props());
const registerDeviceSuccess = createAction('[NGRXTrace - Alerts] Register Device Success', props());
const registerDeviceFail = createAction('[NGRXTrace - Alerts] Register Device Fail', props());
const pushOpened = createAction('[NGRXTrace - Alerts] Push Notification Opened', props());
const pushOpenedSuccess = createAction('[NGRXTrace - Alerts] Push Notification Opened Success', props());
const pushOpenedFail = createAction('[NGRXTrace - Alerts] Push Notification Opened Fail', props());
const PUSH_NOTIFICATIONS_ACTIONS = {
    registerDevice,
    registerDeviceSuccess,
    registerDeviceFail,
    pushOpened,
    pushOpenedSuccess,
    pushOpenedFail,
};

const trackQRCode = createAction('[NGRXTrace - Alerts] Track QR Code', props());
const trackQRCodeSuccess = createAction('[NGRXTrace - Alerts] Track QR Code Success', props());
const trackQRCodeFail = createAction('[NGRXTrace - Alerts] Track QR Code Fail', props());
const QR_CODE_ACTIONS = {
    trackQRCode,
    trackQRCodeSuccess,
    trackQRCodeFail,
};

const TRACE_CONTEXT = {
    getAlerts: 'getAlerts',
    getNotes: 'getNotes',
    getUnreadAlertsCount: 'getUnreadAlertsCount',
    getUnreadNotesCount: 'getUnreadNotesCount',
    markAlertAsRead: 'markAlertAsRead',
    markNoteAsRead: 'markNoteAsRead',
    registerDevice: 'registerDevice',
    pushOpened: 'pushOpened',
    trackQRCode: 'trackQRCode',
};

const NOTIFICATION_KEY = 'notification';
const NOTIFICATION_COUNT_KEY = 'notification-count';
const NOTIFICATION_PREFERENCES_KEY = 'notification-preferences';
const NOTE_KEY = 'note';
const ALERTS_DOMAIN_NAME = 'alerts';
const ALERTS_STORAGE_KEYS = [
    NOTIFICATION_KEY,
    NOTIFICATION_COUNT_KEY,
    NOTE_KEY,
    NOTIFICATION_PREFERENCES_KEY,
];

const noteAdapter = createEntityAdapter({
    selectId: (note) => note.noteId,
});
const initialNoteState = noteAdapter.getInitialState({
    loading: false,
    loaded: false,
    error: null,
});
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
const _noteReducer = createReducer(initialNoteState, on(NOTES_ACTIONS.getNotes, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
})), on(NOTES_ACTIONS.getNotesSuccess, (state, { notes }) => noteAdapter.setAll(notes, {
    ...state,
    loading: false,
    loaded: true,
})), on(NOTES_ACTIONS.getNotesFail, (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: action.error,
})), on(NOTES_ACTIONS.loadFromUserOfflineStorageSuccess, (state, action) => ({
    ...state,
    ...action.notes,
})), on(NOTES_ACTIONS.markNoteAsRead, (state, action) => ({
    ...state,
})), on(NOTES_ACTIONS.markNoteAsReadSuccess, (state, action) => {
    if (action?.response?.noteIds === 'all') {
        return noteAdapter.map((n) => {
            if (n.usersRead?.indexOf(action?.response?.userId) === -1) {
                const updateUsersRead = Object.assign([], n.usersRead);
                updateUsersRead.push(action?.response?.userId);
                return { ...n, usersRead: updateUsersRead };
            }
            else {
                return n;
            }
        }, {
            ...state,
        });
    }
    else {
        return noteAdapter.map((n) => {
            if (action?.response?.noteIds?.indexOf(n.noteId.toString()) > -1 &&
                n.usersRead?.indexOf(action?.response?.userId) === -1) {
                const updateUsersRead = Object.assign([], n.usersRead);
                updateUsersRead.push(action?.response?.userId);
                return { ...n, usersRead: updateUsersRead };
            }
            else {
                return n;
            }
        }, {
            ...state,
        });
    }
}), on(NOTES_ACTIONS.markNoteAsReadFail, (state, action) => ({
    ...state,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function noteReducer(state, action) {
    return _noteReducer(state, action);
}
const { selectAll: selectAll$2, selectEntities: selectEntities$4, selectIds: selectIds$2, selectTotal: selectTotal$2, } = noteAdapter.getSelectors();

const selectAllNotes = selectAll$2;
const selectEntities$3 = selectEntities$4;
const selectNoteContextState = createFeatureSelector(NOTE_KEY);
const getAllNotes = createSelector(selectNoteContextState, selectAllNotes);
const selectNoteWithId = (noteId) => createSelector(selectNoteContextState, (noteState) => {
    const note = noteState.entities[noteId];
    return note;
});
const noteSelectors = {
    selectNoteContextState,
    getAllNotes,
    selectAllNotes,
    selectEntities: selectEntities$3,
    selectNoteWithId,
};

const defaultTransformerFunc = (tracking) => ({
    ...tracking.data,
});

const NGRX_ALERTS_LIB_CONFIG = new InjectionToken('NGRX_ALERTS_LIB_CONFIG');

class HttpClientService {
    constructor(config, http) {
        this.config = config;
        this.http = http;
    }
    /**
     * @param path relative path of the resource
     * @param traceContext optional trace context
     */
    get(path, traceContext) {
        const url = `${this.config.apiUrl}/${path}`;
        const requestOptions = {
            headers: new HttpHeaders({
                'content-type': 'application/json',
                'consumer-id': 'ecomr4',
                'trace-context': traceContext,
            }),
        };
        return this.http
            .get(url, {
            ...requestOptions,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param body the body of the put call
     * @param params optional additional HttpParams
     */
    put(path, body, params) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http
            .put(url, body || {}, {
            params,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param traceContext optional trace context
     */
    patch(path, traceContext) {
        const url = `${this.config.apiUrl}/${path}`;
        const requestOptions = {
            headers: new HttpHeaders({
                'content-type': 'application/json',
                'consumer-id': 'ecomr4',
                'trace-context': traceContext,
            }),
        };
        return this.http
            .patch(url, {
            ...requestOptions,
        })
            .pipe(catchError(this.handleError));
    }
    patchBody(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        const requestOptions = {
            headers: new HttpHeaders({
                'content-type': 'application/json',
                'consumer-id': 'ecomr4',
            }),
        };
        return this.http
            .patch(url, {
            body,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param body the body of the post call
     * @param params optional additional HttpParams
     */
    post(path, body, params) {
        let url = `${this.config.apiUrl}/${path}`;
        url = url.replace('alerts-domain-api', 'push-domain-api');
        return this.http
            .post(url, body || {}, {
            params,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param path relative path of the resource
     * @param body the body of the delete call
     */
    delete(path, body) {
        const url = `${this.config.apiUrl}/${path}`;
        return this.http
            .request('delete', url, { body })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param errror - error response received from the api request
     * @returns empty Observable
     */
    handleError(error) {
        return throwError(error);
    }
}
HttpClientService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpClientService, deps: [{ token: NGRX_ALERTS_LIB_CONFIG }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
HttpClientService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpClientService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpClientService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_ALERTS_LIB_CONFIG]
                }] }, { type: i1.HttpClient }]; } });

class NoteService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    getNotes() {
        return this.serviceHandler
            .get('notes', TRACE_CONTEXT.getNotes)
            ?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
    markNoteAsRead(noteIds) {
        return this.serviceHandler
            .patch('notes?noteIds=' + noteIds, TRACE_CONTEXT.markNoteAsRead)
            ?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
NoteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
NoteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class NotificationStateService {
    constructor(browserStorageService, store, panAppState) {
        this.browserStorageService = browserStorageService;
        this.store = store;
        this.panAppState = panAppState;
        this.end$ = new Subject();
    }
    initializeUserStorage(user) {
        const dbInfo = [];
        dbInfo.push({
            dbName: `${user.userId}_${ALERTS_DOMAIN_NAME}`,
            objectStoreNames: ALERTS_STORAGE_KEYS,
        });
        return this.browserStorageService.initialize({ dbInfo });
    }
    initializeStore() {
        this.panAppState.user$
            .pipe(filter((user) => !!user && user.hasOwnProperty('assignedCustomers')), take(1))
            .subscribe((user) => {
            this.store.dispatch(ALERTS_ACTIONS.initializeUserStorage({ user }));
        });
    }
    getFromUserOfflineStorage(user, storeEntityName) {
        const dbName = `${user?.userId}_${ALERTS_DOMAIN_NAME}`;
        return this.browserStorageService.loadFromOfflineStorage(dbName, storeEntityName);
    }
    writeToUserOfflineStorage(user, storeEntityName, state) {
        const dbName = `${user?.userId}_${ALERTS_DOMAIN_NAME}`;
        return this.browserStorageService.indexDB(dbName, storeEntityName, '0', state, MessageTypes.saveBrowserStorage);
    }
}
NotificationStateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationStateService, deps: [{ token: i1$1.BrowserStorageService }, { token: i1$2.Store }, { token: i4.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationStateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationStateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.BrowserStorageService }, { type: i1$2.Store }, { type: i4.PanAppState }]; } });

class NoteEffects {
    constructor(actions$, noteService, notificationStateService, panAppState, store, router, location) {
        this.actions$ = actions$;
        this.noteService = noteService;
        this.notificationStateService = notificationStateService;
        this.panAppState = panAppState;
        this.store = store;
        this.router = router;
        this.location = location;
        this.getNotes$ = createEffect(() => this.actions$.pipe(ofType(NOTES_ACTIONS.getNotes), exhaustMap(() => this.noteService.getNotes().pipe(switchMap((notes) => [
            NOTES_ACTIONS.getNotesSuccess({
                notes,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.getNotes,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(NOTES_ACTIONS.getNotesFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.getNotes,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
        this.getNotesSuccess$ = createEffect(() => this.actions$.pipe(ofType(NOTES_ACTIONS.getNotesSuccess), switchMap(() => [NOTES_ACTIONS.writeToUserOfflineStorage()])));
        this.markNoteAsRead$ = createEffect(() => this.actions$.pipe(ofType(NOTES_ACTIONS.markNoteAsRead), switchMap((payload) => this.noteService.markNoteAsRead(payload?.noteIds).pipe(concatMap((response) => [
            NOTES_ACTIONS.markNoteAsReadSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.markNoteAsRead,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(NOTES_ACTIONS.markNoteAsReadFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.markNoteAsRead,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
        // IndexedDB
        this.writeNotesToOfflineStorage$ = createEffect(() => this.actions$.pipe(ofType(NOTES_ACTIONS.writeToUserOfflineStorage), withLatestFrom(this.panAppState.user$, this.store.select(noteSelectors.selectNoteContextState)), distinctUntilChanged(), concatMap(([_, user, notes]) => this.notificationStateService.writeToUserOfflineStorage(user, NOTE_KEY, notes))), { dispatch: false });
        this.loadFromUserStorage$ = createEffect(() => this.actions$.pipe(ofType(NOTES_ACTIONS.loadFromUserOfflineStorage), concatMap((param) => this.notificationStateService
            .getFromUserOfflineStorage(param.user, NOTE_KEY)
            .pipe(map((notes) => NOTES_ACTIONS.loadFromUserOfflineStorageSuccess({ notes })), catchError((error) => of(NOTES_ACTIONS.loadFromUserOfflineStorageFail({ error })))))));
        this.loadFromUserOfflineStorageSuccess$ = createEffect(() => this.actions$.pipe(ofType(NOTES_ACTIONS.loadFromUserOfflineStorageSuccess, NOTES_ACTIONS.loadFromUserOfflineStorageFail), withLatestFrom(this.panAppState.session$), concatMap(([_, session]) => {
            if (!session.isGuest) {
                return [
                    NOTES_ACTIONS.getNotes({
                        tracking: {
                            tracing: {
                                data: {
                                    traceContext: TRACE_CONTEXT.getNotes,
                                    isStartOfTrace: true,
                                    isEndOfTrace: false,
                                },
                                transformFunc: defaultTransformerFunc,
                            },
                        },
                    }),
                ];
            }
            return [];
        })));
    }
}
NoteEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteEffects, deps: [{ token: i1$3.Actions }, { token: NoteService }, { token: NotificationStateService }, { token: i4.PanAppState }, { token: i1$2.Store }, { token: i6.Router }, { token: i7.Location }], target: i0.ɵɵFactoryTarget.Injectable });
NoteEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: NoteService }, { type: NotificationStateService }, { type: i4.PanAppState }, { type: i1$2.Store }, { type: i6.Router }, { type: i7.Location }]; } });

const notificationAdapter = createEntityAdapter({
    selectId: (notification) => notification.alertBatchId,
});
const initialNotificationState = notificationAdapter.getInitialState({
    loading: false,
    error: null,
});
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
const _notificationReducer = createReducer(initialNotificationState, on(ALERTS_ACTIONS.getAlerts, (state) => ({
    ...state,
    loading: true,
    error: null,
})), on(ALERTS_ACTIONS.getAlertsSuccess, (state, { alerts }) => notificationAdapter.setAll(alerts, {
    ...state,
    loading: false,
})), on(ALERTS_ACTIONS.getAlertsFail, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})), on(ALERTS_ACTIONS.loadFromUserOfflineStorageSuccess, (state, action) => ({
    ...state,
    ...action.alerts,
})), on(ALERTS_ACTIONS.markAlertAsRead, (state, action) => {
    if (action.alertBatchIds === 'all') {
        return notificationAdapter.map((n) => (n.read === false || !n.read ? { ...n, read: true } : n), {
            ...state,
        });
    }
    else {
        return {
            ...state,
        };
    }
}), on(ALERTS_ACTIONS.markAlertAsReadSuccess, (state, action) => {
    if (action.response?.alertBatchIds === 'all') {
        return notificationAdapter.map((n) => (n.read === false || !n.read ? { ...n, read: true } : n), {
            ...state,
        });
    }
    else {
        return notificationAdapter.map((n) => action.response?.alertBatchIds?.indexOf(n.alertBatchId) > -1
            ? { ...n, read: true }
            : n, {
            ...state,
        });
    }
}), on(ALERTS_ACTIONS.markAlertAsReadFail, (state, action) => ({
    ...state,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function notificationReducer(state, action) {
    return _notificationReducer(state, action);
}
const { selectAll: selectAll$1, selectEntities: selectEntities$2, selectIds: selectIds$1, selectTotal: selectTotal$1, } = notificationAdapter.getSelectors();

const selectAllNotifications = selectAll$1;
const selectEntities$1 = selectEntities$2;
const selectNotificationContextState = createFeatureSelector(NOTIFICATION_KEY);
const getAllNotifications = createSelector(selectNotificationContextState, selectAllNotifications);
const selectNotificationWithId = (alertBatchId) => createSelector(selectNotificationContextState, (notificationState) => {
    const notification = notificationState.entities[alertBatchId];
    return notification;
});
const notificationSelectors = {
    selectNotificationContextState,
    getAllNotifications,
    selectAllNotifications,
    selectEntities: selectEntities$1,
    selectNotificationWithId,
};

class NotificationService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    getAlerts() {
        return this.serviceHandler
            .get('alerts', TRACE_CONTEXT.getAlerts)
            ?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
    getUnreadAlertsCount() {
        return this.serviceHandler
            .get('alerts-count', TRACE_CONTEXT.getUnreadAlertsCount)
            ?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
    markAlertAsRead(alertBatchIds) {
        return this.serviceHandler
            .patch('alerts?alertBatchIds=' + alertBatchIds, TRACE_CONTEXT.markAlertAsRead)
            ?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
NotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class NotificationEffects {
    constructor(actions$, notificationService, notificationStateService, panAppState, store, router, location) {
        this.actions$ = actions$;
        this.notificationService = notificationService;
        this.notificationStateService = notificationStateService;
        this.panAppState = panAppState;
        this.store = store;
        this.router = router;
        this.location = location;
        this.getAlerts$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.getAlerts), exhaustMap(() => this.notificationService.getAlerts().pipe(switchMap((alerts) => [
            ALERTS_ACTIONS.getAlertsSuccess({
                alerts,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.getAlerts,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(ALERTS_ACTIONS.getAlertsFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.getAlerts,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
        this.getAlertsSuccess$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.getAlertsSuccess), switchMap(() => [ALERTS_ACTIONS.writeToUserOfflineStorage()])));
        this.getUnreadAlertsCount$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.getUnreadAlertsCount), exhaustMap((payload) => this.notificationService.getUnreadAlertsCount().pipe(switchMap((alertCount) => [
            ALERTS_ACTIONS.getUnreadAlertsCountSuccess({
                alertCount,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.getUnreadAlertsCount,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(ALERTS_ACTIONS.getUnreadAlertsCountFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.getUnreadAlertsCount,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
        this.markAlertAsRead$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.markAlertAsRead), switchMap((payload) => this.notificationService.markAlertAsRead(payload.alertBatchIds).pipe(concatMap((response) => [
            ALERTS_ACTIONS.markAlertAsReadSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.markAlertAsRead,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(ALERTS_ACTIONS.markAlertAsReadFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.markAlertAsRead,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
        // IndexedDB
        this.writeNotificationsToOfflineStorage$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.writeToUserOfflineStorage), withLatestFrom(this.panAppState.user$, this.store.select(notificationSelectors.selectNotificationContextState)), distinctUntilChanged(), concatMap(([_, user, alerts]) => this.notificationStateService.writeToUserOfflineStorage(user, NOTIFICATION_KEY, alerts))), { dispatch: false });
        this.initializeUserStorage$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.initializeUserStorage), concatMap((param) => this.notificationStateService
            .initializeUserStorage(param.user)
            .pipe(map(() => ALERTS_ACTIONS.loadFromUserOfflineStorage(param))))));
        this.loadFromUserStorage$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.loadFromUserOfflineStorage), concatMap((param) => this.notificationStateService
            .getFromUserOfflineStorage(param.user, NOTIFICATION_KEY)
            .pipe(map((alerts) => ALERTS_ACTIONS.loadFromUserOfflineStorageSuccess({ alerts })), catchError((error) => of(ALERTS_ACTIONS.loadFromUserOfflineStorageFail({ error })))))));
        this.loadFromUserOfflineStorageSuccess$ = createEffect(() => this.actions$.pipe(ofType(ALERTS_ACTIONS.loadFromUserOfflineStorageSuccess, ALERTS_ACTIONS.loadFromUserOfflineStorageFail), withLatestFrom(this.panAppState.session$), concatMap(([_, session]) => {
            if (!session.isGuest) {
                return [
                    ALERTS_ACTIONS.getAlerts({
                        tracking: {
                            tracing: {
                                data: {
                                    traceContext: TRACE_CONTEXT.getAlerts,
                                    isStartOfTrace: true,
                                    isEndOfTrace: false,
                                },
                                transformFunc: defaultTransformerFunc,
                            },
                        },
                    }),
                ];
            }
            return [];
        })));
    }
}
NotificationEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationEffects, deps: [{ token: i1$3.Actions }, { token: NotificationService }, { token: NotificationStateService }, { token: i4.PanAppState }, { token: i1$2.Store }, { token: i6.Router }, { token: i7.Location }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: NotificationService }, { type: NotificationStateService }, { type: i4.PanAppState }, { type: i1$2.Store }, { type: i6.Router }, { type: i7.Location }]; } });

class PushNotificationService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    registerDevice(registerDeviceRequest, userName) {
        const request = { ...registerDeviceRequest, userName };
        if (localStorage.getItem('ecomr4-push-device-info')) {
            const storedData = JSON.parse(localStorage.getItem('ecomr4-push-device-info'));
            if (storedData?.registered &&
                storedData?.userName === request?.userName &&
                storedData?.deviceId === request?.deviceId &&
                storedData?.deviceToken === request?.deviceToken) {
                return of(null);
            }
            else {
                storedData.registered = true;
                storedData.userName = request.userName;
                localStorage.setItem('ecomr4-push-device-info', JSON.stringify(storedData));
                return this.serviceHandler
                    .post('push/registerDevice', request)
                    ?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
            }
        }
    }
    pushOpened(pushOpenedRequest, userName) {
        const request = {
            ...pushOpenedRequest,
            userName,
        };
        return this.serviceHandler.post('push/pushOpened', request)?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
PushNotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PushNotificationService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
PushNotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PushNotificationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PushNotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class PushNotificationsEffects {
    constructor(actions$, pushNotificationService, panAppState) {
        this.actions$ = actions$;
        this.pushNotificationService = pushNotificationService;
        this.panAppState = panAppState;
        this.registerDevice$ = createEffect(() => this.actions$.pipe(ofType(PUSH_NOTIFICATIONS_ACTIONS.registerDevice), withLatestFrom(this.panAppState.user$), switchMap(([params, user]) => this.pushNotificationService
            .registerDevice(params.registerDeviceRequest, user.userId)
            .pipe(switchMap((response) => [
            PUSH_NOTIFICATIONS_ACTIONS.registerDeviceSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.registerDevice,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(PUSH_NOTIFICATIONS_ACTIONS.registerDeviceFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.registerDevice,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
        this.pushOpened$ = createEffect(() => this.actions$.pipe(ofType(PUSH_NOTIFICATIONS_ACTIONS.pushOpened), withLatestFrom(this.panAppState.user$), switchMap(([params, user]) => this.pushNotificationService
            .pushOpened(params.pushOpenedRequest, user.userId)
            .pipe(switchMap((response) => [
            PUSH_NOTIFICATIONS_ACTIONS.pushOpenedSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.pushOpened,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(PUSH_NOTIFICATIONS_ACTIONS.pushOpenedFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.pushOpened,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
    }
}
PushNotificationsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PushNotificationsEffects, deps: [{ token: i1$3.Actions }, { token: PushNotificationService }, { token: i4.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
PushNotificationsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PushNotificationsEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PushNotificationsEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: PushNotificationService }, { type: i4.PanAppState }]; } });

class QRCodeService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    trackQRCode(qrCodeString, qrCodeRequest) {
        const request = { ...qrCodeRequest };
        return this.serviceHandler
            .patchBody('qr-code?data=' + qrCodeString, request)
            ?.pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
QRCodeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: QRCodeService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
QRCodeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: QRCodeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: QRCodeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class QRCodeEffects {
    constructor(actions$, qrCodeService) {
        this.actions$ = actions$;
        this.qrCodeService = qrCodeService;
        this.trackQRCode$ = createEffect(() => this.actions$.pipe(ofType(QR_CODE_ACTIONS.trackQRCode), switchMap((params) => this.qrCodeService
            .trackQRCode(params.qrCodeString, params.qrCodeRequest)
            .pipe(switchMap((response) => [
            QR_CODE_ACTIONS.trackQRCodeSuccess({
                response,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.trackQRCode,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(QR_CODE_ACTIONS.trackQRCodeFail({
                error,
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.trackQRCode,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }));
        })))));
    }
}
QRCodeEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: QRCodeEffects, deps: [{ token: i1$3.Actions }, { token: QRCodeService }], target: i0.ɵɵFactoryTarget.Injectable });
QRCodeEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: QRCodeEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: QRCodeEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: QRCodeService }]; } });

const notificationCountAdapter = createEntityAdapter({
    selectId: (alertCount) => alertCount?.userId,
});
const initialNotificationCountState = notificationCountAdapter.getInitialState({
    loading: false,
    error: null,
    alertCount: 0,
    noteCount: 0,
});
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
const _notificationCountReducer = createReducer(initialNotificationCountState, on(ALERTS_ACTIONS.getUnreadAlertsCount, (state, action) => ({
    ...state,
    loading: true,
})), on(ALERTS_ACTIONS.getUnreadAlertsCountSuccess, (state, action) => notificationCountAdapter.upsertOne(action.alertCount, {
    ...state,
    ids: [],
    entities: {},
})), on(ALERTS_ACTIONS.getUnreadAlertsCountFail, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function notificationCountReducer(state, action) {
    return _notificationCountReducer(state, action);
}
const { selectAll, selectEntities, selectIds, selectTotal, } = notificationCountAdapter.getSelectors();

const NG_RX_ALERTS_EVENTS = {
    namespace: 'Alert',
    eventType: ['UnreadAlertsCountEvent'],
};

class AlertsClientWebSocketService {
    constructor(webSocketService, store) {
        this.webSocketService = webSocketService;
        this.store = store;
        this.subscriptions = [];
        /**
         * @remarks
         * This method maps the incoming websocket event event action defined in @usf/alert-types
         * to the appropriate NgRx action.  New events can be added to the map without impacting performance
         *
         * @param eventAction - The action attached to the websocket event
         * @param event - The data attached to the websocket event
         * @returns The NgRx action that will interact with the store
         */
        /* istanbul ignore next */
        this.handleEvent = (eventAction, event) => ({
            [AlertEventActions.UnreadAlertCount]: () => ALERTS_ACTIONS.getUnreadAlertsCountSuccess({
                alertCount: event.data.messageContent[0],
                tracking: {
                    tracing: {
                        data: {
                            traceContext: TRACE_CONTEXT.getUnreadAlertsCount,
                            isStartOfTrace: false,
                            isEndOfTrace: true,
                        },
                        transformFunc: defaultTransformerFunc,
                    },
                },
            }),
        }[eventAction]());
    }
    initialize() {
        // if there is no websocket service injected, return out
        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (!this.webSocketService['baseUrl']) {
            // eslint-disable-next-line no-console
            console.info('%c** no websocket injected for alerts domain **', 'color: black; font-weight:bold;');
            return;
        }
        // subscribe to the websocket events scoped to the alerts domain
        // panamax websocket service lib will handle keeping the websocket connection
        // alive and will update the isConnected$ observable accordingly
        this.subscriptions.push(this.webSocketService?.isConnected$.subscribe((connected) => {
            if (connected) {
                // Register websocket namespace and event types to subscribe to
                this.webSocketService.register([NG_RX_ALERTS_EVENTS]);
                this.subscriptions.push(this.webSocketService?.getTopicData().subscribe((event) => {
                    let eventData;
                    try {
                        /* istanbul ignore next */
                        if (this.isObject(JSON.parse(event?.data))) {
                            eventData = JSON.parse(event?.data);
                            // dispatch appropriate NgRx action based on incoming websocket event action
                            if (eventData?.data?.namespace === 'Alert' &&
                                eventData?.data?.eventAction) {
                                if (eventData?.data?.messageContent) {
                                    this.store.dispatch(this.handleEvent(eventData?.data?.eventAction, eventData));
                                }
                            }
                        }
                        else {
                            eventData = null;
                        }
                    }
                    catch (e) { }
                }));
            }
            else {
                // eslint-disable-next-line no-console
                console.info('%c** alerts domain web socket disconnected. **', 'color: red; font-weight:bold;');
            }
        }));
    }
    isObject(obj) {
        return obj === Object(obj);
    }
}
AlertsClientWebSocketService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertsClientWebSocketService, deps: [{ token: i1$4.WebSocketService }, { token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Injectable });
AlertsClientWebSocketService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertsClientWebSocketService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertsClientWebSocketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.WebSocketService }, { type: i1$2.Store }]; } });

const initialNotificationPreferencesState = {
    emailAddress: '',
    recipientId: '',
    emailActive: undefined,
    pushActive: undefined,
    ecUserId: '',
    activeGroupId: '',
    groups: {
        entities: {},
        ids: [],
    },
    types: {
        entities: {},
        ids: [],
    },
    customers: {
        entities: {},
        ids: [],
    },
    notifications: {
        entities: {},
        ids: [],
    },
    loaded: false,
    loading: false,
    error: null,
};

// Action Creators
const loadAlertInfo = createAction('[Notification Preferences] Load Alert Info');
const loadAlertInfoSuccess = createAction('[Notification Preferences] Load Alert Info Success', props());
const loadAlertInfoFailure = createAction('[Notification Preferences] Load Alert Info Failure', props());
const loadNotificationPreferences = createAction('[Notification Preferences] Load Notification Preferences', props());
const loadNotificationPreferencesSuccess = createAction('[Notification Preferences] Load Notification Preferences Success', props());
const loadNotificationPreferencesFailure = createAction('[Notification Preferences] Load Notification Preferences Failure', props());
const setActiveNotificationType = createAction('[Notification Preferences] Set active Notification Type', props());
const setBulkNotificationPreferences = createAction('[Notification Preferences] Set bulk Notification Preferences', props());
const setBulkNotificationPreferencesSuccess = createAction('[Notification Preferences] Set bulk Notification Preferences Success', props());
const setBulkNotificationPreferencesFailure = createAction('[Notification Preferences] Set bulk Notification Preferences Failure', props());
const updateUserNotificationEmailAddress = createAction('[Notification Preferences] Update user Notification email address');
const updateUserNotificationEmailAddressSuccess = createAction('[Notification Preferences] Update user Notification email address Success', props());
const updateUserNotificationEmailAddressFailure = createAction('[Notification Preferences] Update user Notification email address Failure', props());
const updateUserNotificationPhoneNumber = createAction('[Notification Preferences] Update user Notification phone number');
const updateUserNotificationPhoneNumberSuccess = createAction('[Notification Preferences] Update user Notification phone number Success', props());
const updateUserNotificationPhoneNumberFailure = createAction('[Notification Preferences] Update user Notification phone number Failure', props());
const updateDeliveryForAlertType = createAction('[Notification Preferences] Update delivery method for Alert Type');
const updateDeliveryForAlertTypeSuccess = createAction('[Notification Preferences] Update delivery method for Alert Type Success', props());
const updateDeliveryForAlertTypeFailure = createAction('[Notification Preferences] Update delivery method for Alert Type Failure', props());
const updateCustomerListForAlertType = createAction('[Notification Preferences] Update active customer list for Alert Type');
const updateCustomerListForAlertTypeSuccess = createAction('[Notification Preferences] Update active customer list for Alert Type Success', props());
const updateCustomerListForAlertTypeFailure = createAction('[Notification Preferences] Update active customer list for Alert Type Failure', props());
const updateDeliveryForAlertId = createAction('[Notification Preferences] Update delivery method for AlertId');
const updateDeliveryForAlertIdSuccess = createAction('[Notification Preferences] Update delivery method for Alert Id Success', props());
const updateDeliveryForAlertIdFailure = createAction('[Notification Preferences] Update delivery method for Alert Id Failure', props());
const updateCustomerListForAlertId = createAction('[Notification Preferences] Update active customer list for AlertId');
const updateCustomerListForAlertIdSuccess = createAction('[Notification Preferences] Update active customer list for AlertId Success', props());
const updateCustomerListForAlertIdFailure = createAction('[Notification Preferences] Update active customer list for AlertId Failure', props());
const loadAllCustomerWarningDisabled = createAction('[Notification Preferences] Fetch all customers off warning disabled');
const loadAllCustomersWarningDisabledSuccess = createAction('[Notification Preferences] Fetch all customers off warning disabled Success', props());
const loadAllCustomersWarningDisabledFailure = createAction('[Notification Preferences] Fetch all customers off warning disabled Failure', props());
const updateAllCustomerWarningDisabled = createAction('[Notification Preferences] Update all customers warning disabled');
const updateAllCustomersWarningDisabledSuccess = createAction('[Notification Preferences] Update all customers warning disabled Success', props());
const updateAllCustomersWarningDisabledFailure = createAction('[Notification Preferences] Update all customers warning disabled Failure', props());
const saveNotificationPreferences = createAction('[Notification Preferences] Save Notification Preferences', props());
const saveNotificationPreferencesSuccess = createAction('[Notification Preferences] Save Notification Preferences Success', props());
const saveNotificationPreferencesFailure = createAction('[Notification Preferences] Save Notification Preferences Failure', props());
const NOTIFICATION_PREFERENCES_ACTIONS = {
    loadAlertInfo,
    loadAlertInfoSuccess,
    loadAlertInfoFailure,
    loadNotificationPreferences,
    loadNotificationPreferencesSuccess,
    loadNotificationPreferencesFailure,
    setActiveNotificationType,
    setBulkNotificationPreferences,
    setBulkNotificationPreferencesSuccess,
    setBulkNotificationPreferencesFailure,
    updateUserNotificationEmailAddress,
    updateUserNotificationEmailAddressSuccess,
    updateUserNotificationEmailAddressFailure,
    updateUserNotificationPhoneNumber,
    updateUserNotificationPhoneNumberSuccess,
    updateUserNotificationPhoneNumberFailure,
    updateDeliveryForAlertType,
    updateDeliveryForAlertTypeSuccess,
    updateDeliveryForAlertTypeFailure,
    updateCustomerListForAlertType,
    updateCustomerListForAlertTypeSuccess,
    updateCustomerListForAlertTypeFailure,
    updateDeliveryForAlertId,
    updateDeliveryForAlertIdSuccess,
    updateDeliveryForAlertIdFailure,
    updateCustomerListForAlertId,
    updateCustomerListForAlertIdSuccess,
    updateCustomerListForAlertIdFailure,
    loadAllCustomerWarningDisabled,
    loadAllCustomersWarningDisabledSuccess,
    loadAllCustomersWarningDisabledFailure,
    updateAllCustomerWarningDisabled,
    updateAllCustomersWarningDisabledSuccess,
    updateAllCustomersWarningDisabledFailure,
    saveNotificationPreferences,
    saveNotificationPreferencesSuccess,
    saveNotificationPreferencesFailure,
};

// Helper function to convert notification options to delivery methods
const asDeliveryMethods = (notificationOptions) => {
    const enabledDeliveryMethods = [];
    const availableDeliveryMethods = [];
    Object.keys(notificationOptions).forEach((key) => {
        if (key === 'email') {
            availableDeliveryMethods.push('EMAIL');
            // eslint-disable-next-line @typescript-eslint/dot-notation
            if (notificationOptions['email']) {
                enabledDeliveryMethods.push('EMAIL');
            }
        }
        else if (key === 'push') {
            availableDeliveryMethods.push('PUSH');
            // eslint-disable-next-line @typescript-eslint/dot-notation
            if (notificationOptions['push']) {
                enabledDeliveryMethods.push('PUSH');
            }
        }
    });
    return {
        enabled: enabledDeliveryMethods,
        available: availableDeliveryMethods,
    };
};
const asNotificationGroupId = (alertId, groupName) => `${alertId}_${groupName}`;
const notificationPreferencesReducer = createReducer(initialNotificationPreferencesState, on(NOTIFICATION_PREFERENCES_ACTIONS.loadAlertInfo, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
})), 
// Alert Info reducers
on(NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferences, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
})), on(NOTIFICATION_PREFERENCES_ACTIONS.loadAlertInfoSuccess, (state, { alertInfo }) => updateStateWithAlertInfo(state, alertInfo)), on(NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferencesSuccess, (state, { notificationPreferences }) => {
    const stateTypeEntities = {
        ...state.types.entities,
    };
    const stateTypeIds = [...state.types.ids];
    const stateGroupEntities = {
        ...state.groups.entities,
    };
    const stateGroupIds = [...state.groups.ids];
    const stateNotificationEntities = {
        ...state.notifications.entities,
    };
    const stateNotificationIds = [...state.notifications.ids];
    const stateCustomerEntities = {
        ...state.customers.entities,
    };
    const stateCustomerIds = [...state.customers.ids];
    // Extract user data from first response
    const { emailAddress, userId, } = extractMetadata(notificationPreferences);
    // Process from notification preferences
    updateStateWithUserNotificationPreferences(notificationPreferences, stateTypeEntities, stateTypeIds, stateGroupEntities, stateGroupIds, stateNotificationEntities, stateNotificationIds, stateCustomerEntities, stateCustomerIds);
    const result = {
        ...state,
        emailAddress: emailAddress,
        recipientId: userId || '',
        ecUserId: userId || '',
        emailActive: hasEnabledDeliveryMethod(Object.values(stateGroupEntities), 'EMAIL'),
        pushActive: hasEnabledDeliveryMethod(Object.values(stateGroupEntities), 'PUSH'),
        notifications: {
            entities: stateNotificationEntities,
            ids: stateNotificationIds,
        },
        groups: {
            entities: stateGroupEntities,
            ids: stateGroupIds,
        },
        types: {
            entities: stateTypeEntities,
            ids: stateTypeIds,
        },
        customers: {
            entities: stateCustomerEntities,
            ids: stateCustomerIds,
        },
        loading: false,
        loaded: true,
        error: null,
    };
    return result;
}), 
// Set Active Notification Group reducers
on(NOTIFICATION_PREFERENCES_ACTIONS.setActiveNotificationType, (state, { activeTypeId }) => ({
    ...state,
    activeTypeId,
})));
const extractMetadata = (notificationPreferences) => {
    // Get the first populated userId
    const userId = notificationPreferences.find((pref) => pref.userId)?.userId || '';
    // Find any notification with an email value
    let emailAddress = '';
    for (const pref of notificationPreferences) {
        const emailNotification = pref.notificationType?.find((n) => n.type === 'email');
        if (emailNotification?.value) {
            emailAddress = emailNotification.value;
            break;
        }
    }
    return {
        emailAddress,
        userId,
    };
};
const hasEnabledDeliveryMethod = (groups, deliveryMethod) => groups.some((group) => group.enabledDeliveryMethods.includes(deliveryMethod));
const isPushAvailable = (alertGroup) => alertGroup !== 'TRUCK_DELIVERY' && alertGroup !== 'ORDER_STATUS';
const updateStateWithUserNotificationPreferences = (notificationPreferences, stateTypeEntities, stateTypeIds, stateGroupEntities, stateGroupIds, stateNotificationEntities, stateNotificationIds, stateCustomerEntities, stateCustomerIds) => {
    notificationPreferences.forEach((pref) => {
        let stateType;
        let stateGroup;
        const groupId = asNotificationGroupId(pref.alertType, pref.alertGroup);
        if (!stateTypeEntities[pref.alertType]) {
            stateTypeIds.push(pref.alertType);
            stateType = {
                id: pref.alertType,
                name: pref.alertType,
                notificationGroupIds: [],
            };
        }
        else {
            stateType = {
                ...stateTypeEntities[pref.alertType],
                name: pref.alertType,
            };
        }
        stateTypeEntities[pref.alertType] = stateType;
        if (!stateGroupEntities[groupId]) {
            stateGroupIds.push(groupId);
            stateGroup = {
                id: groupId,
                name: pref.alertGroup,
                userId: pref.userId,
                userName: pref.userName,
                availableDeliveryMethods: [],
                enabledCustomerIds: [],
                enabledDeliveryMethods: [],
                emailAddress: '',
                notificationIds: [],
            };
        }
        else {
            stateGroup = {
                ...stateGroupEntities[groupId],
                userId: pref.userId,
                userName: pref.userName,
                availableDeliveryMethods: [
                    ...stateGroupEntities[groupId].availableDeliveryMethods,
                ],
                enabledCustomerIds: [],
                enabledDeliveryMethods: [
                    ...stateGroupEntities[groupId].enabledDeliveryMethods,
                ],
                emailAddress: '',
                notificationIds: [...stateGroupEntities[groupId].notificationIds],
            };
        }
        stateGroupEntities[groupId] = stateGroup;
        if (!(stateType.notificationGroupIds || []).includes(groupId)) {
            stateType.notificationGroupIds.push(groupId);
        }
        if (pref.notificationType?.length > 0) {
            // Track which delivery methods are present and enabled in current preferences
            const presentDeliveryMethods = [];
            const enabledDeliveryMethods = [];
            pref.notificationType.forEach((notification) => {
                if (notification.type === 'email') {
                    presentDeliveryMethods.push('EMAIL');
                    if (notification.value !== '') {
                        enabledDeliveryMethods.push('EMAIL');
                    }
                }
                if (notification.type === 'push' && isPushAvailable(pref.alertGroup)) {
                    presentDeliveryMethods.push('PUSH');
                    if (notification.value === true) {
                        enabledDeliveryMethods.push('PUSH');
                    }
                }
            });
            // Update available delivery methods based on what's present
            stateGroup.availableDeliveryMethods = presentDeliveryMethods;
            // Update enabled delivery methods based on what's actually enabled
            stateGroup.enabledDeliveryMethods = enabledDeliveryMethods;
            // Set isEnabled based on whether there are any enabled delivery methods
            stateGroup.isEnabled = stateGroup.enabledDeliveryMethods.length > 0;
            // Update enabled customers based on current preferences
            if (pref.customers?.length > 0) {
                stateGroup.enabledCustomerIds = pref.customers.map((customer) => customer.customerNumber.toString());
            }
            else {
                stateGroup.enabledCustomerIds = [];
            }
        }
        else {
            // If no notification types, clear all delivery methods and customers
            stateGroup.availableDeliveryMethods = [];
            stateGroup.enabledDeliveryMethods = [];
            stateGroup.enabledCustomerIds = [];
            stateGroup.isEnabled = false;
        }
        pref.alertIds.forEach((alert) => {
            let stateNotification;
            if (!stateNotificationEntities[alert.alertId]) {
                stateNotificationIds.push(alert.alertId);
                stateNotification = {
                    id: alert.alertId,
                    description: alert.alertName,
                };
            }
            else {
                stateNotification = {
                    ...stateNotificationEntities[pref.alertType],
                };
            }
            stateNotificationEntities[alert.alertId] = stateNotification;
            if (!(stateGroup.notificationIds || []).includes(alert.alertId)) {
                stateGroup.notificationIds.push(alert.alertId);
            }
        });
        // Update customer entities
        pref.customers?.forEach((customer) => {
            let stateCustomer;
            const customerNumber = customer.customerNumber.toString();
            if (!stateCustomerEntities[customerNumber]) {
                stateCustomerIds.push(customerNumber);
                stateCustomer = {
                    customerNumber: customer.customerNumber.toString(),
                    divisionNumber: customer.divisionNumber.toString(),
                };
            }
            else {
                stateCustomer = {
                    ...stateCustomerEntities[customerNumber],
                };
            }
            stateCustomerEntities[customerNumber] = stateCustomer;
        });
    });
};
const updateStateWithAlertInfo = (state, alertInfo) => {
    const stateTypeIds = [...state.types.ids];
    const stateTypeEntities = {
        ...state.types.entities,
    };
    const stateGroupIds = [...state.groups.ids];
    const stateGroupEntities = {
        ...state.groups.entities,
    };
    alertInfo.alerts.forEach((alert) => {
        let stateType;
        if (!state.types.entities[alert.alertType]) {
            stateTypeIds.push(alert.alertType);
            stateType = {
                id: alert.alertType,
                name: alert.alertType,
                notificationGroupIds: [],
            };
        }
        else {
            stateType = { ...state.types.entities[alert.alertType] };
        }
        alert.alerts.forEach((inputGroup) => {
            const groupId = asNotificationGroupId(alert.alertType, inputGroup.alertName);
            let stateGroup;
            if (!state.groups.entities[groupId]) {
                stateGroupIds.push(groupId);
                stateGroup = {
                    id: groupId,
                    name: inputGroup.alertName,
                    isEnabled: inputGroup.alertEnabled,
                    availableDeliveryMethods: [],
                    enabledCustomerIds: [],
                    enabledDeliveryMethods: [],
                    emailAddress: '',
                    notificationIds: [],
                };
            }
            else {
                const originalGroup = state.groups.entities[groupId];
                stateGroup = {
                    ...originalGroup,
                    notificationIds: originalGroup.notificationIds
                        ? [...originalGroup.notificationIds]
                        : [],
                    enabledCustomerIds: originalGroup.enabledCustomerIds
                        ? [...originalGroup.enabledCustomerIds]
                        : [],
                    enabledDeliveryMethods: originalGroup.enabledDeliveryMethods
                        ? [...originalGroup.enabledDeliveryMethods]
                        : [],
                    availableDeliveryMethods: [],
                };
            }
            if (!inputGroup.alertEnabled) {
                stateGroup.isEnabled = false;
                stateGroup.enabledCustomerIds = [];
                stateGroup.enabledDeliveryMethods = [];
            }
            if (inputGroup.notificationOptions.length > 0) {
                if (inputGroup.notificationOptions[0].email) {
                    stateGroup.availableDeliveryMethods.push('EMAIL');
                }
                if (inputGroup.notificationOptions[0].push) {
                    stateGroup.availableDeliveryMethods.push('PUSH');
                }
            }
            if (!stateType.notificationGroupIds.includes(groupId)) {
                stateType.notificationGroupIds.push(groupId);
            }
            stateGroupEntities[groupId] = stateGroup;
        });
        stateTypeEntities[alert.alertType] = stateType;
    });
    return {
        ...state,
        ecUserId: alertInfo.userId,
        emailActive: alertInfo.emailActive,
        pushActive: alertInfo.pushActive,
        types: { ...state.types, entities: stateTypeEntities, ids: stateTypeIds },
        groups: {
            ...state.groups,
            entities: stateGroupEntities,
            ids: stateGroupIds,
        },
        loaded: true,
        loading: false,
        error: null,
    };
};

// Helper functions for mapping state objects to facade objects
const mapStateCustomerToNotificationCustomer = (customer) => ({
    customerNumber: customer.customerNumber,
    divisionNumber: customer.divisionNumber,
});
const mapStateNotificationToNotification = (notification) => ({
    id: notification.id,
    description: notification.description || '',
});
const mapStateGroupToNotificationGroup = (group, customers, notifications) => ({
    id: group.id,
    name: group.name,
    isEnabled: group.isEnabled,
    enabledDeliveryMethods: group.enabledDeliveryMethods || [],
    availableDeliveryMethods: group.availableDeliveryMethods || [],
    enabledCustomers: (group.enabledCustomerIds || []).map((customerNumber) => mapStateCustomerToNotificationCustomer(customers[customerNumber])),
    notifications: (group.notificationIds || []).map((notificationId) => mapStateNotificationToNotification(notifications[notificationId])),
});
const mapStateTypeToNotificationType = (type, groups, customers, notifications) => ({
    type: type.id,
    groups: type.notificationGroupIds.map((groupId) => mapStateGroupToNotificationGroup(groups[groupId], customers, notifications)),
});
const selectNotificationPreferencesState = (state) => state[NOTIFICATION_PREFERENCES_KEY];
const selectNotificationTypesState = createSelector(selectNotificationPreferencesState, (state) => state.types.entities);
const selectHasActiveEmail = createSelector(selectNotificationPreferencesState, (state) => state.emailActive);
const selectHasActivePush = createSelector(selectNotificationPreferencesState, (state) => state.pushActive);
const selectNotificationGroupsState = createSelector(selectNotificationPreferencesState, (state) => state.groups.entities);
const selectNotificationCustomersState = createSelector(selectNotificationPreferencesState, (state) => state.customers.entities);
const selectNotificationsState = createSelector(selectNotificationPreferencesState, (state) => state.notifications.entities);
const selectActiveTypeId = createSelector(selectNotificationPreferencesState, (state) => state.activeTypeId);
// Force re-evaluation of the selector when activeTypeId changes
const selectActiveNotificationType = createSelector(selectActiveTypeId, selectNotificationTypesState, selectNotificationGroupsState, selectNotificationCustomersState, selectNotificationsState, (activeTypeId, types, groups, customers, notifications) => {
    const type = types[activeTypeId];
    return type
        ? mapStateTypeToNotificationType(type, groups, customers, notifications)
        : undefined;
});
const selectNotificationPreferences = createSelector(selectNotificationPreferencesState, selectNotificationTypesState, selectNotificationGroupsState, selectNotificationCustomersState, selectNotificationsState, (state, types, groups, customers, notifications) => ({
    emailAddress: state.emailAddress,
    recipientId: state.recipientId,
    emailActive: state.emailActive,
    pushActive: state.pushActive,
    ecUserId: state.ecUserId,
    types: Object.values(types).map((type) => mapStateTypeToNotificationType(type, groups, customers, notifications)),
    loading: state.loading,
    loaded: state.loaded,
    error: state.error,
}));
const selectActiveNotificationGroupPreferences = createSelector(selectNotificationPreferencesState, selectNotificationGroupsState, selectNotificationCustomersState, selectNotificationsState, (state, groups, customers, notifications) => state.activeGroupId
    ? mapStateGroupToNotificationGroup(groups[state.activeGroupId], customers, notifications)
    : undefined);
// ONLY EXPOSE DERIVED SELECTORS THAT RETURN TRANSFORMED DATA
const notificationPreferencesSelectors = {
    selectHasActiveEmail,
    selectHasActivePush,
    selectNotificationPreferences,
    selectActiveNotificationGroupPreferences,
    selectActiveNotificationType,
    selectActiveTypeId,
};

class NotificationPreferencesService {
    constructor(serviceHandler) {
        this.serviceHandler = serviceHandler;
    }
    getAlertInfo() {
        return this.serviceHandler.get(`userNotificationPreferences/alert-info`, 'NotificationPreferencesService.getAlertInfo');
    }
    getNotificationPreferences(alertType) {
        return this.serviceHandler.get(`userNotificationPreferences/notification-preferences?alertType=${alertType}`, 'NotificationPreferencesService.getNotificationPreferences');
    }
    saveNotificationPreferences(request) {
        return this.serviceHandler.put(`userNotificationPreferences/preferences`, request);
    }
    saveBulkNotificationPreferences(request) {
        return this.serviceHandler.put(`userNotificationPreferences/bulk`, request);
    }
}
NotificationPreferencesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesService, deps: [{ token: HttpClientService }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationPreferencesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: HttpClientService }]; } });

class NotificationPreferencesEffects {
    constructor(actions$, store, notificationPreferencesService) {
        this.actions$ = actions$;
        this.store = store;
        this.notificationPreferencesService = notificationPreferencesService;
        this.loadAlertinfo$ = createEffect(() => this.actions$.pipe(ofType(NOTIFICATION_PREFERENCES_ACTIONS.loadAlertInfo), switchMap(() => this.notificationPreferencesService.getAlertInfo()), map((alertInfo) => NOTIFICATION_PREFERENCES_ACTIONS.loadAlertInfoSuccess({
            alertInfo,
        })), catchError((error) => of(NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferencesFailure({
            error: error.message || 'Failed to load Alert Info',
        })))));
        // Load Notification Preferences effect
        this.loadNotificationPreferences$ = createEffect(() => this.actions$.pipe(ofType(NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferences), switchMap(({ notificationTypeId }) => this.notificationPreferencesService.getNotificationPreferences(notificationTypeId)), map((notificationPreferences) => NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferencesSuccess({
            notificationPreferences,
        })), catchError((error) => of(NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferencesFailure({
            error: error.message || 'Failed to load Notification Preferences',
        })))));
        this.saveNotificationPreferences$ = createEffect(() => this.actions$.pipe(ofType(NOTIFICATION_PREFERENCES_ACTIONS.saveNotificationPreferences), concatLatestFrom(() => this.store.select(notificationPreferencesSelectors.selectActiveTypeId)), switchMap(([{ request }, activeTypeId]) => this.notificationPreferencesService
            .saveNotificationPreferences(request)
            .pipe(map((success) => ({
            success,
            activeTypeId,
        })))), mergeMap(({ success, activeTypeId }) => [
            NOTIFICATION_PREFERENCES_ACTIONS.saveNotificationPreferencesSuccess({
                success,
            }),
            NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferences({
                notificationTypeId: activeTypeId,
            }),
        ]), catchError((error) => of(NOTIFICATION_PREFERENCES_ACTIONS.saveNotificationPreferencesFailure({
            error: error.message || 'Failed to save Notification Preferences',
        })))));
        this.saveBulkNotificationPreferences$ = createEffect(() => this.actions$.pipe(ofType(NOTIFICATION_PREFERENCES_ACTIONS.setBulkNotificationPreferences), switchMap(({ request }) => this.notificationPreferencesService.saveBulkNotificationPreferences(request)), mergeMap((success) => [
            NOTIFICATION_PREFERENCES_ACTIONS.setBulkNotificationPreferencesSuccess({
                success,
            }),
            NOTIFICATION_PREFERENCES_ACTIONS.loadAlertInfo(),
        ]), catchError((error) => of(NOTIFICATION_PREFERENCES_ACTIONS.setBulkNotificationPreferencesFailure({
            error: error.message || 'Failed to set Bulk Notification Preferences',
        })))));
    }
}
NotificationPreferencesEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesEffects, deps: [{ token: i1$3.Actions }, { token: i1$2.Store }, { token: NotificationPreferencesService }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationPreferencesEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: i1$2.Store }, { type: NotificationPreferencesService }]; } });

/* istanbul ignore next */
class NgRxAlertsModule {
    constructor(ngRxAlertsLibConfig, store, panAppState, webSocketService) {
        this.ngRxAlertsLibConfig = ngRxAlertsLibConfig;
        this.store = store;
        this.panAppState = panAppState;
        this.webSocketService = webSocketService;
        this.subscripions = [];
    }
    static forRoot(ngRxAlertsLibConfig, store, panAppState, webSocketService) {
        return {
            ngModule: NgRxAlertsModule,
            providers: [
                {
                    provide: NGRX_ALERTS_LIB_CONFIG,
                    useValue: ngRxAlertsLibConfig,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeWebSocket,
                    deps: [AlertsClientWebSocketService],
                    multi: true,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeNotificationService,
                    deps: [NotificationStateService],
                    multi: true,
                },
            ],
        };
    }
}
NgRxAlertsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxAlertsModule, deps: [{ token: NGRX_ALERTS_LIB_CONFIG }, { token: i1$2.Store }, { token: i4.PanAppState }, { token: i1$4.WebSocketService, optional: true }], target: i0.ɵɵFactoryTarget.NgModule });
NgRxAlertsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: NgRxAlertsModule, imports: [i1$2.StoreFeatureModule, i1$2.StoreFeatureModule, i1$2.StoreFeatureModule, i1$2.StoreFeatureModule, i1$3.EffectsFeatureModule] });
NgRxAlertsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxAlertsModule, providers: [
        HttpClientService,
        NotificationEffects,
        NoteEffects,
        PushNotificationsEffects,
        NotificationStateService,
        QRCodeService,
    ], imports: [StoreModule.forFeature(NOTIFICATION_KEY, notificationReducer),
        StoreModule.forFeature(NOTIFICATION_COUNT_KEY, notificationCountReducer),
        StoreModule.forFeature(NOTIFICATION_PREFERENCES_KEY, notificationPreferencesReducer),
        StoreModule.forFeature(NOTE_KEY, noteReducer),
        EffectsModule.forFeature([
            NotificationEffects,
            NoteEffects,
            PushNotificationsEffects,
            QRCodeEffects,
            NotificationPreferencesEffects,
        ])] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxAlertsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        StoreModule.forFeature(NOTIFICATION_KEY, notificationReducer),
                        StoreModule.forFeature(NOTIFICATION_COUNT_KEY, notificationCountReducer),
                        StoreModule.forFeature(NOTIFICATION_PREFERENCES_KEY, notificationPreferencesReducer),
                        StoreModule.forFeature(NOTE_KEY, noteReducer),
                        EffectsModule.forFeature([
                            NotificationEffects,
                            NoteEffects,
                            PushNotificationsEffects,
                            QRCodeEffects,
                            NotificationPreferencesEffects,
                        ]),
                    ],
                    providers: [
                        HttpClientService,
                        NotificationEffects,
                        NoteEffects,
                        PushNotificationsEffects,
                        NotificationStateService,
                        QRCodeService,
                    ],
                    exports: [],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_ALERTS_LIB_CONFIG]
                }] }, { type: i1$2.Store }, { type: i4.PanAppState }, { type: i1$4.WebSocketService, decorators: [{
                    type: Optional
                }] }]; } });
/* istanbul ignore next */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function initializeNotificationService(notificationState) {
    const state = () => notificationState.initializeStore();
    return state;
}
/* istanbul ignore next */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function initializeWebSocket(webSocketService) {
    const websocket = () => webSocketService.initialize();
    return websocket;
}

const selectUnreadAlertsCountState = createFeatureSelector(NOTIFICATION_COUNT_KEY);
const selectUnreadAlertsCount = () => createSelector(selectUnreadAlertsCountState, (state) => state);
const notificationCountSelectors = {
    selectUnreadAlertsCountState,
    selectUnreadAlertsCount,
};

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class NoteStoreService {
    constructor(store) {
        this.store = store;
    }
    retrieveNotes() {
        this.store.dispatch(NOTES_ACTIONS.getNotes({
            tracking: {
                tracing: {
                    data: {
                        traceContext: TRACE_CONTEXT.getNotes,
                        isStartOfTrace: true,
                        isEndOfTrace: false,
                    },
                    transformFunc: defaultTransformerFunc,
                },
            },
        }));
    }
    getNoteWithId(noteId) {
        return this.store.select(noteSelectors.selectNoteWithId(noteId));
    }
}
NoteStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteStoreService, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Injectable });
NoteStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NoteStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Store }]; } });

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class NotificationStoreService {
    constructor(store) {
        this.store = store;
    }
    retrieveNotifications() {
        this.store.dispatch(ALERTS_ACTIONS.getAlerts({
            tracking: {
                tracing: {
                    data: {
                        traceContext: TRACE_CONTEXT.getAlerts,
                        isStartOfTrace: true,
                        isEndOfTrace: false,
                    },
                    transformFunc: defaultTransformerFunc,
                },
            },
        }));
    }
    getNotificationWithId(alertBatchId) {
        return this.store.select(notificationSelectors.selectNotificationWithId(alertBatchId));
    }
}
NotificationStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationStoreService, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Store }]; } });

const ANALYTICS_ACTIONS = {
    trackingAlertsPageLoad: createAction('[NgRxClient Analytics] - Track Alerts page Load', props()),
    trackingAlertDetailsPageLoad: createAction('[NgRxClient Analytics] - Track Alert Details page Load', props()),
    trackingAlertFiltersApplied: createAction('[NgRxClient Analytics] - Track Alert Filters Applied', props()),
    trackingTmNotesPageLoad: createAction('[NgRxClient Analytics] - Track TM Notes page Load', props()),
    trackingOrderedProductsUnavailablePageLoad: createAction('[NgRxClient Analytics] - Ordered Products Unavailable page load', props()),
    trackingAddProductsToNextDeliveryClick: createAction('[NgRxClient Analytics] - Add products to next delivery button click', props()),
    trackingWarehouseCutsPushNotificationClick: createAction('[NgRxClient Analytics] - Warehouse Cuts Push Notification Click', props()),
    trackingShareFileReviewOrder: createAction('[NgRxClient Analytics] - File share Review Order', props()),
    trackingShareFileReviewOrderModalOpen: createAction('[NgRxClient Analytics] - File share Review Order modal open', props()),
    trackingShareFileOrderConfirmation: createAction('[NgRxClient Analytics] - File share Order Confirmation', props()),
    trackingShareFileOrderConfirmationModalOpen: createAction('[NgRxClient Analytics] - File share Order Confirmation modal open', props()),
    trackingAShareFileProductCompare: createAction('[NgRxClient Analytics] - File share Product Compare', props()),
    trackingShareFilePaymentConfirmation: createAction('[NgRxClient Analytics] - File share Payment Confirmation', props()),
    trackSharePaymentConfirmationModalOpen: createAction('[NgRxClient Analytics] - Share Payment Confirmation modal open', props()),
    trackProductCompareModalOpen: createAction('[NgRxClient Analytics] - Share Product Compare modal open', props()),
};

/* eslint-disable no-shadow */
var AnalyticMessages;
(function (AnalyticMessages) {
    AnalyticMessages["capability"] = "alerts";
    AnalyticMessages["alertsPageName"] = "us foods:r4:alerts";
    AnalyticMessages["alertDetailsPageName"] = "us foods:r4:alerts:delivery issues";
    AnalyticMessages["pageLoadedEvent"] = "page loaded";
    AnalyticMessages["alertFiltersApplied"] = "filters applied";
    AnalyticMessages["tmNotesPageName"] = "us foods:r4:tm notes";
    AnalyticMessages["orderedProductsUnavailablePageName"] = "us foods:r4:ordered products unavailable";
    AnalyticMessages["buttonClickEvent"] = "button click";
    AnalyticMessages["addProductsToNextDeliveryButtonName"] = "add to next delivery";
    AnalyticMessages["warehouseCutPushNotificationClickEvent"] = "notification center card";
    AnalyticMessages["warehouseCutAlertId"] = "100051";
    AnalyticMessages["shareCsvEvent"] = "share csv";
    AnalyticMessages["modalOpenEvent"] = "modal open";
    AnalyticMessages["sharePdfEvent"] = "share pdf";
    AnalyticMessages["fileTypeShareReviewOrder"] = "share:review order:email";
    AnalyticMessages["modalNameShareReviewOrder"] = "share file review order";
    AnalyticMessages["fileTypeShareOrderConfirmation"] = "share:order confirmation:email";
    AnalyticMessages["modalNameShareOrderConfirmation"] = "share file order confirmation";
    AnalyticMessages["fileTypeShareProductCompare"] = "share:product compare:email";
    AnalyticMessages["fileTypeSharePaymentConfirmation"] = "share:payment confirmation:email";
    AnalyticMessages["modalNameSharePaymentConfirmation"] = "share file payment confirmation";
    AnalyticMessages["modalNameShareProductCompare"] = "share file product compare";
})(AnalyticMessages || (AnalyticMessages = {}));

/* istanbul ignore next */
/**
 * ALERTS PAGE LOAD
 *
 * @param tracking
 * @returns Data Layer needed for tracking the Alerts Page Load
 */
const alertsPageLoad = (tracking) => ({
    page: {
        pageName: tracking.data.pageName,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
    filters: JSON.stringify(tracking.data.filters) === 'null'
        ? ''
        : JSON.stringify(tracking.data.filters)
            .replace(/],/g, ';')
            .replace(/"/g, '')
            .replace(/:/g, '=')
            .replace(/\[/g, '')
            .replace(/]/g, '')
            .replace(/{/g, '')
            .replace(/}/g, ''),
});
/* istanbul ignore next */
/**
 * ALERT DETAILS PAGE LOAD
 *
 * @param tracking
 * @returns Data Layer needed for tracking the Alert Details Page Load
 */
const alertDetailPageLoad = (tracking) => ({
    page: {
        pageName: tracking.data.pageName,
    },
    alertBatchId: tracking.data.alertBatchId,
    event: tracking.data.event,
    capability: tracking.data.capability,
});
/* istanbul ignore next */
/**
 * ALERT FILTERS APPLIED
 *
 * @param tracking
 * @returns Data Layer needed for tracking the Alert Filters Applied
 */
const alertFiltersApplied = (tracking) => ({
    event: tracking.data.event,
    capability: tracking.data.capability,
    filters: JSON.stringify(tracking.data.filters) === 'null'
        ? ''
        : JSON.stringify(tracking.data.filters)
            .replace(/],/g, ';')
            .replace(/"/g, '')
            .replace(/:/g, '=')
            .replace(/\[/g, '')
            .replace(/]/g, '')
            .replace(/{/g, '')
            .replace(/}/g, ''),
});
/* istanbul ignore next */
/**
 * TM NOTES PAGE LOAD
 *
 * @param tracking
 * @returns Data Layer needed for tracking the TM Notes Page Load
 */
const tmNotesPageLoad = (tracking) => ({
    page: {
        pageName: tracking.data.pageName,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
    promo: tracking.data.promo,
    products: tracking.data.products,
});
/* istanbul ignore next */
/**
 * Ordered Products Unavailable page load
 *
 * @param tracking
 * @returns Data Layer needed for tracking the Ordered Products Unavailable
 * page load
 */
const orderedProductsUnavailablePageLoad = (tracking) => ({
    page: {
        pageName: tracking.data.pageName,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
});
/* istanbul ignore next */
/**
 * Add Products to next Order clicked
 *
 * @param tracking
 * @returns Data Layer needed for tracking the Add Products to next delivery
 * button click
 */
const addProductsToNextDeliveryClick = (tracking) => ({
    button: {
        buttonName: tracking.data.buttonName,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
});
/* istanbul ignore next */
/**
 * Warehouse Cuts Push Notification Click
 *
 * @param tracking
 * @returns Data Layer needed for tracking the Warehouse Cuts Push Notification click
 */
const warehouseCutsPushNotificationClick = (tracking) => ({
    alert: {
        type: tracking.data.alertId,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
});
/* istanbul ignore next */
/**
 * Transform file share tracking data
 *
 * @param tracking
 * @returns Data Layer needed for tracking file share
 */
const shareFileTransformFn = (tracking) => ({
    file: {
        type: tracking.data.fileType,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
});
/* istanbul ignore next */
/**
 * Transform modal open tracking data
 *
 * @param tracking
 * @returns Data Layer needed for tracking modal open
 */
const modalOpenTransformFn = (tracking) => ({
    modal: {
        name: tracking.data.modalName,
    },
    event: tracking.data.event,
    capability: tracking.data.capability,
});

class AlertAnalyticsService {
    constructor(store) {
        this.store = store;
    }
    /**
     * ALERTS PAGE
     */
    trackAlertsPageLoad(filters) {
        const tracking = {
            analytics: {
                data: {
                    pageName: AnalyticMessages.alertsPageName,
                    event: AnalyticMessages.pageLoadedEvent,
                    capability: AnalyticMessages.capability,
                    filters,
                },
                transformFunc: alertsPageLoad,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingAlertsPageLoad({ tracking }));
    }
    /**
     * ALERT DETAILS PAGE
     */
    trackAlertDetailPageLoad(alertBatchId) {
        const tracking = {
            analytics: {
                data: {
                    pageName: AnalyticMessages.alertDetailsPageName,
                    event: AnalyticMessages.pageLoadedEvent,
                    capability: AnalyticMessages.capability,
                    alertBatchId,
                },
                transformFunc: alertDetailPageLoad,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingAlertDetailsPageLoad({ tracking }));
    }
    /**
     * ALERT FILTERS APPLIED
     */
    trackAlertFiltersApplied(filters) {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.alertFiltersApplied,
                    capability: AnalyticMessages.capability,
                    filters,
                },
                transformFunc: alertFiltersApplied,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingAlertFiltersApplied({ tracking }));
    }
    trackTmNotesPageLoad(noteIdList, productTrackingInfos) {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.pageLoadedEvent,
                    capability: AnalyticMessages.capability,
                    pageName: AnalyticMessages.tmNotesPageName,
                    promo: {
                        list: noteIdList,
                        view: 1,
                    },
                    products: productTrackingInfos,
                },
                transformFunc: tmNotesPageLoad,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingTmNotesPageLoad({ tracking }));
    }
    /**
     * ORDERED PRODUCTS UNAVAILABLE PAGE LOAD
     */
    trackOrderedProductsUnavailablePageLoad() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.pageLoadedEvent,
                    capability: AnalyticMessages.capability,
                    pageName: AnalyticMessages.orderedProductsUnavailablePageName,
                },
                transformFunc: orderedProductsUnavailablePageLoad,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingOrderedProductsUnavailablePageLoad({ tracking }));
    }
    /**
     * ADD PRODUCTS TO NEXT DELIVERY CLICKED
     */
    trackAddProductsToNextDeliveryClick() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.buttonClickEvent,
                    capability: AnalyticMessages.capability,
                    buttonName: AnalyticMessages.addProductsToNextDeliveryButtonName,
                },
                transformFunc: addProductsToNextDeliveryClick,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingAddProductsToNextDeliveryClick({ tracking }));
    }
    /**
     * WAREHOUSE CUTS PUSH NOTIFICATION CLICK
     */
    trackWarehouseCutsPushNotificationClick() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.warehouseCutPushNotificationClickEvent,
                    capability: AnalyticMessages.capability,
                    alertId: AnalyticMessages.warehouseCutAlertId,
                },
                transformFunc: warehouseCutsPushNotificationClick,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingWarehouseCutsPushNotificationClick({ tracking }));
    }
    /**
     * SHARE FILE REVIEW ORDER
     */
    trackShareFileReviewOrder() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.shareCsvEvent,
                    capability: AnalyticMessages.capability,
                    fileType: AnalyticMessages.fileTypeShareReviewOrder,
                },
                transformFunc: shareFileTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingShareFileReviewOrder({ tracking }));
    }
    /**
     * SHARE FILE REVIEW ORDER MODAL OPEN
     */
    trackShareFileReviewOrderModalOpen() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.modalOpenEvent,
                    capability: AnalyticMessages.capability,
                    modalName: AnalyticMessages.modalNameShareReviewOrder,
                },
                transformFunc: modalOpenTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingShareFileReviewOrderModalOpen({ tracking }));
    }
    /**
     * SHARE FILE ORDER CONFIRMATION
     */
    trackShareFileOrderConfirmation() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.shareCsvEvent,
                    capability: AnalyticMessages.capability,
                    fileType: AnalyticMessages.fileTypeShareOrderConfirmation,
                },
                transformFunc: shareFileTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingShareFileOrderConfirmation({ tracking }));
    }
    /**
     * SHARE FILE ORDER COMFIRMATION MODAL OPEN
     */
    trackShareFileOrderConfirmationModalOpen() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.modalOpenEvent,
                    capability: AnalyticMessages.capability,
                    modalName: AnalyticMessages.modalNameShareOrderConfirmation,
                },
                transformFunc: modalOpenTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingShareFileOrderConfirmationModalOpen({
            tracking,
        }));
    }
    /**
     * SHARE FILE PRODUCT COMPARE
     */
    trackShareFileProductCompare(fileType) {
        const tracking = {
            analytics: {
                data: {
                    event: fileType === 'PDF'
                        ? AnalyticMessages.sharePdfEvent
                        : AnalyticMessages.shareCsvEvent,
                    capability: AnalyticMessages.capability,
                    fileType: AnalyticMessages.fileTypeShareProductCompare,
                },
                transformFunc: shareFileTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingAShareFileProductCompare({ tracking }));
    }
    /**
     * SHARE FILE PAYMENT CONFIRMATION
     */
    trackShareFilePaymentConfirmation() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.sharePdfEvent,
                    capability: AnalyticMessages.capability,
                    fileType: AnalyticMessages.fileTypeSharePaymentConfirmation,
                },
                transformFunc: shareFileTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackingShareFilePaymentConfirmation({ tracking }));
    }
    /**
     * SHARE PAYMENT COMFIRMATION MODAL OPEN
     */
    trackSharePaymentConfirmationModalOpen() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.modalOpenEvent,
                    capability: AnalyticMessages.capability,
                    modalName: AnalyticMessages.modalNameSharePaymentConfirmation,
                },
                transformFunc: modalOpenTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackSharePaymentConfirmationModalOpen({
            tracking,
        }));
    }
    /**
     * SHARE PRODUCT COMPARE MODAL OPEN
     */
    trackProductCompareModalOpen() {
        const tracking = {
            analytics: {
                data: {
                    event: AnalyticMessages.modalOpenEvent,
                    capability: AnalyticMessages.capability,
                    modalName: AnalyticMessages.modalNameShareProductCompare,
                },
                transformFunc: modalOpenTransformFn,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackProductCompareModalOpen({
            tracking,
        }));
    }
}
AlertAnalyticsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertAnalyticsService, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Injectable });
AlertAnalyticsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertAnalyticsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlertAnalyticsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Store }]; } });

class NotificationPreferencesStateService {
    constructor(store) {
        this.store = store;
        this.notificationPreferences$ = this.store.select(notificationPreferencesSelectors.selectNotificationPreferences);
        this.activeTypeId$ = this.store.select(notificationPreferencesSelectors.selectActiveTypeId);
        this.activeNotificationType$ = this.store.select(notificationPreferencesSelectors.selectActiveNotificationType);
    }
    selectNotificationPreferences$() {
        return this.notificationPreferences$;
    }
    selectActiveTypeId$() {
        return this.activeTypeId$;
    }
    selectActiveNotificationType$() {
        return this.activeNotificationType$;
    }
    loadNotificationPreferences() {
        this.store.dispatch(NOTIFICATION_PREFERENCES_ACTIONS.loadAlertInfo());
    }
    loadNotificationTypeDetails(notificationTypeId) {
        this.store.dispatch(NOTIFICATION_PREFERENCES_ACTIONS.loadNotificationPreferences({
            notificationTypeId,
        }));
    }
    setActiveNotificationType(activeTypeId) {
        this.store.dispatch(NOTIFICATION_PREFERENCES_ACTIONS.setActiveNotificationType({
            activeTypeId,
        }));
    }
    saveNotificationPreferences(request) {
        this.store.dispatch(NOTIFICATION_PREFERENCES_ACTIONS.saveNotificationPreferences({ request }));
    }
    setBulkNotificationPreferences(emailOff, pushOff) {
        this.store.dispatch(NOTIFICATION_PREFERENCES_ACTIONS.setBulkNotificationPreferences({
            request: {
                setAllEmailOff: emailOff,
                setAllPushOff: pushOff,
            },
        }));
    }
}
NotificationPreferencesStateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesStateService, deps: [{ token: i1$2.Store }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationPreferencesStateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesStateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NotificationPreferencesStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.Store }]; } });

/*
 * Public API Surface of ngrx-alerts
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ALERTS_ACTIONS, AlertAnalyticsService, AlertsClientWebSocketService, NOTES_ACTIONS, NgRxAlertsModule, NoteService, NoteStoreService, NotificationPreferencesStateService, NotificationService, NotificationStateService, NotificationStoreService, PUSH_NOTIFICATIONS_ACTIONS, PushNotificationService, QRCodeService, QR_CODE_ACTIONS, TRACE_CONTEXT, addProductsToNextDeliveryClick, alertDetailPageLoad, alertFiltersApplied, alertsPageLoad, initialNoteState, initialNotificationCountState, initialNotificationState, modalOpenTransformFn, noteAdapter, noteReducer, noteSelectors, notificationAdapter, notificationCountAdapter, notificationCountReducer, notificationCountSelectors, notificationReducer, notificationSelectors, orderedProductsUnavailablePageLoad, shareFileTransformFn, tmNotesPageLoad, warehouseCutsPushNotificationClick };
